<template>
  <form class="contact-form">
    <template v-if="! sended && ! loading">
      <div class="columns">
        <div class="column is-half py-0">
          <input-field v-model="input.firstname" :label="lang('Nome')"
                       name="firstname" :errors="errors" required></input-field>
        </div>
        <div class="column is-half py-0">
          <input-field v-model="input.lastname" :label="lang('Cognome')"
                       name="lastname" :errors="errors" required></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column py-0">
          <input-field v-model="input.company" :label="lang('Ragione Sociale')"
                       name="company" :errors="errors"></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half py-0">
          <input-field v-model="input.email" :label="lang('Indirizzo Email')"
                       name="email" type="email" :errors="errors" required></input-field>
        </div>
        <div class="column is-half py-0">
          <input-field v-model="input.phone" :label="lang('Telefono')"
                       name="phone" type="text" :errors="errors" required></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column py-0">
          <select-fetch v-if="language === 'it'" v-model="input.province" :label="lang('Provincia')" name="province" :errors="errors" endpoint="provinces" ordering="id" required></select-fetch>
          <select-fetch v-else v-model="input.country" :label="lang('Paese')" name="country" :errors="errors" endpoint="countries" required></select-fetch>
        </div>
      </div>
      <div class="columns">
        <div class="column py-0">
          <textarea-field v-model="input.body" :label="lang('Messaggio')"
                          name="body" :errors="errors" required
                          :rows="10"></textarea-field>
        </div>
      </div>
      <div class="contact-policies">
        <div class="policy-card">
          <h4 class="policy-card-title" v-text="lang('Informativa sulla Privacy')"></h4>
          <p>{{
              lang("Desideriamo informarVi le modalità di conservazione dei vostri dati, incluso le finalità e tempistiche. In ogni momento sarà possibile visualizzare i dati in nostro possesso, modificarli e richiederne la cancellazione. Per poter procedere con l'invio del presente form è obbligatorio acconsentire alla nostra Informativa sulla privacy, che può essere consultata in maniera completa al seguente link")
            }} <a target="_blank" href="/policies/privacy">https://www.daku.it/policies/privacy</a>
          </p>
          <checkbox v-model="input.privacy" name="privacy" :errors="errors">
            {{ lang('Acconsento al trattamento dei miei dati come riportato nella') }} <a target="_blank"
                                                                                          href="/policies/privacy"
                                                                                          v-text="lang('Informativa sulla Privacy')"></a>
            {{ lang('di Daku Italia S.r.l') }}
          </checkbox>
        </div>
      </div>
      <div class="has-text-centered">
        <button @click.prevent="send" class="button is-primary" v-text="lang('Invia')"></button>
      </div>
    </template>
    <div v-if="loading" class="loading" style="margin-top: 3rem">
      <div class="has-text-centered">
        <div class="icon"><i class="fas fa-5x fa-spin fa-circle-notch"></i></div>
      </div>
    </div>
    <div v-if="sended" class="contact-thx has-text-centered">
      <p v-text="lang('Grazie per averci contattato. Un nostro addetto ti risponderà quanto prima.')"></p>
    </div>
  </form>
</template>
<script>
import FormErrors from './../Classes/FormErrors'
import axios from 'axios'

export default {
  data() {
    return {
      provinces: [],
      countries: [],
      input: {
        firstname: '',
        lastname: '',
        company: '',
        email: '',
        phone: '',
        province: '',
        country: '',
        body: '',
        privacy: false
      },
      sended: false,
      loading: false,
      errors: new FormErrors(),
      endpoint: 'https://preventivi.daku.it',
    }
  },
  created() {
    axios.get( this.endpoint+'/api/v1.0/provinces')
        .then(response => this.provinces = response.data)
        .catch(error => {
          this.throttled.error = true;
          this.throttled.message = error.response.data;
        });
    axios.get(this.endpoint+'/api/v1.0/countries')
        .then(response => this.countries = response.data)
        .catch(error => {
          this.throttled.error = true;
          this.throttled.message = error.response.data;
        });
  },
  methods: {
    send() {
      this.loading = true
      axios.post('/contact/send', this.input)
          .then(response => {
            this.sended = true;
            this.loading = false
          })
          .catch(error => {
            console.log(error.response.data.errors);
            this.loading = false
            this.errors.record(error.response.data.errors);
          })
    }
  },
  computed: {
    language() {
      return window.language;
    }
  }
}
</script>
